import { Flex, Heading, Text } from '@chakra-ui/react';
import React from 'react';
var PriceHeader = function (_a) {
    var summaryPrice = _a.summaryPrice;
    return (React.createElement(Flex, { alignItems: 'center', gap: 'xs', justifyContent: 'center' },
        React.createElement(Heading, { color: 'typography.pure', size: '4xl' },
            "$",
            summaryPrice),
        React.createElement(Text, { color: 'typography.pure', fontSize: 'lg', fontWeight: 'semibold' }, "/mth")));
};
export default PriceHeader;
//# sourceMappingURL=PriceHeader.js.map